import { React, UseState, UseEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PageContent from 'layouts/PageContent';
import ValueAdded from './ValueAdded';

const ValueAddedScreen = (props) => {
  const {t, i18n} = useTranslation(['salesPerformance', 'common']);
  
  return (
    <PageContent title={t('salesPerformance:ValueAdded')}>
      <ValueAdded />
    </PageContent>
  )
}

export default ValueAddedScreen;